import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Select as SetlistSelect } from '@opendate-app/setlist';
import { useV3OfferContext, V3_ACTIONS } from '../contexts/V3OfferContext';

const V3OfferSeatMapPicker = () => {
  const { offer, team, csrfToken, confirm, dispatch } = useV3OfferContext() || {};
  const [saving, setSaving] = useState(false);
  const seatMaps = offer?.venue_seat_maps || [];
  if ((confirm && confirm.type !== 'Hold') || seatMaps.length === 0) return null;

  const value = seatMaps.some((chart) => chart.id === offer.seating_chart_id) ? String(offer.seating_chart_id) : '';

  const choose = (picked) => {
    const seatingChartId = picked ? Number(picked) : null;
    setSaving(true);
    axios.patch(`/teams/${team.id}/offers/v3/${offer.id}`, { v3_offer: { seating_chart_id: seatingChartId } }, { headers: { 'X-CSRF-TOKEN': csrfToken } })
      .then(() => dispatch({ type: V3_ACTIONS.UPDATE_OFFER, payload: { seating_chart_id: seatingChartId } }))
      .catch((err) => {
        const detail = Array.isArray(err?.response?.data) ? err.response.data.join(', ') : null;
        toast.error(detail || 'Could not save the seat map.');
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="v3-offer-seat-map" data-testid="v3-offer-seat-map">
      <SetlistSelect
        label="Seat map"
        aria-label="Seat map"
        options={[{ value: '', label: 'No seat map' }, ...seatMaps.map((chart) => ({ value: String(chart.id), label: chart.name }))]}
        value={value}
        disabled={saving}
        onChange={choose}
      />
    </div>
  );
};

V3OfferSeatMapPicker.propTypes = {};

export default V3OfferSeatMapPicker;
